var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.81A2.81 2.81 0 012.81 0h8.217a2.811 2.811 0 012.81 2.81v8.217a2.811 2.811 0 01-2.81 2.81H2.811A2.81 2.81 0 010 11.028V2.811zm10.62 2.405a.648.648 0 00-.916-.917l-3.65 3.65L4.35 6.244a.649.649 0 10-.916.917l2.162 2.162a.649.649 0 00.916 0l4.109-4.108zm-7.593 9.488A2.81 2.81 0 005.397 16h6.059A4.543 4.543 0 0016 11.456V5.398a2.811 2.811 0 00-1.298-2.371v8.429a3.244 3.244 0 01-3.246 3.247H3.027z",
    fill: "#0F1CA2"
  })));
}
export default SvgCheckIcon;